var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.selected)?_c('SelectYear',{on:{"change":function($event){_vm.selected = true}}}):_c('index-chart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }